import exclaimIcon from 'assets/image/icons/svg/exclaim.svg'
import { ResponsiveButton } from 'components/atoms/responsiveButton/index.tsx'
import { useDateHandlers } from 'components/molecules/dateSelection/hooks.ts'
import { CONSTS } from 'config/objectConst.js'
import { notificationUtils } from 'features/notifications/index.ts'
import { workspaceApi } from 'features/workspace'
import { useEffect } from 'react'

import {
	DateSelection,
	DAYS,
	transformToWorkingHours,
	useHasSelected
} from '../../dateSelection/index.ts'
import { SelectTimeZone } from '../../SelectTimeZone/index.tsx'
import { useEditMode, useHours } from './hooks.ts'

function WorkingHours() {
	const { hours, setHours } = useHours()

	const [mutation, mutationOptions] = workspaceApi.useSetWorkingHoursMutation()

	const { cancelEdit, isEdit, tornOff, turnOn } = useEditMode({
		hours,
		setHours
	})

	useEffect(() => {
		if (mutationOptions.isSuccess) {
			notificationUtils.snackById('3.13')
			tornOff()
		}
	}, [mutationOptions.isSuccess, tornOff])

	const saveWorkingHours = () => {
		const { isValid, oneOrMoreSelected, workspaceHours } =
			transformToWorkingHours(hours)

		setHours({ ...hours })

		if (isValid && oneOrMoreSelected) {
			mutation(workspaceHours)
		}
	}

	const hasSelected = useHasSelected(hours)

	const { handleHoursChange, toggleDay } = useDateHandlers(setHours)

	return (
		<>
			<div className='linkedin__timezone'>
				<div className='linkedin__timezone-title'>Time zone:</div>

				<SelectTimeZone />
			</div>

			<div className='working-hours'>
				<div className='working-hours__content'>
					<div className='working-hours__item-flex'>
						<div className='linkedin__timezone-title'>Schedule</div>
						<div className='working-hours__exclaim'>
							<img alt='exclaimIcon' src={exclaimIcon} />
							You can work up to {CONSTS.WORKING_HOURS} hours a day.
						</div>
					</div>
					{DAYS.map(key => {
						return (
							<div className='working-hours__item' key={key}>
								{isEdit ? (
									<DateSelection
										dateSelectionHandler={toggleDay}
										dayOfWeek={key}
										handleDateChange={handleHoursChange}
										hours={hours[key]}
									/>
								) : (
									<div className='working-hours__interval'>
										<p className='working-hours__sub-title'>{key}</p>
										{hours[key].isSelected ? (
											<span className='hour-interval__not-empty'>
												{hours[key].value}
											</span>
										) : (
											<span className='working-hours__interval_empty'>
												__:__-__:__
											</span>
										)}
									</div>
								)}
							</div>
						)
					})}
				</div>
				<div className='working-hours__actions'>
					{isEdit ? (
						<>
							<button className='working-hours__btn' onClick={cancelEdit}>
								Cancel
							</button>

							<ResponsiveButton
								className='working-hours__btn working-hours__btn_with-bg'
								disabled={!hasSelected}
								isLoading={mutationOptions.isLoading}
								onClick={saveWorkingHours}
							>
								{'Apply'}
							</ResponsiveButton>
						</>
					) : (
						<button
							className='working-hours__btn working-hours__btn_with-bg'
							onClick={() => turnOn(hours)}
						>
							Edit
						</button>
					)}
				</div>
			</div>
		</>
	)
}

export default WorkingHours
